import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'semantic-ui-react'

import Container from './PreviewModalImageHoverItemContainer'

import * as styles from './styles'

const PreviewModalImageHoverItem = props => (
  <div
    style={props.position === 'left' ? styles.containerLeft : styles.containerRight}
    onClick={props.onClick}
    onMouseEnter={props.handleMouseEnter}
    onMouseLeave={props.handleMouseLeave}
  >
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
    <a style={props.position === 'right' ? styles.aRight : {}}>
      <Icon
        color={props.lightBackground ? 'black' : null}
        inverted={!props.lightBackground}
        name={`chevron ${props.position}`}
        size="huge"
        style={props.mouseOver ? styles.iconVisible : styles.iconHidden}
        link
      />
    </a>
  </div>
)

PreviewModalImageHoverItem.propTypes = {
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
  lightBackground: PropTypes.bool,
  mouseOver: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  position: PropTypes.oneOf(['left', 'right']),
}

export default Container(PreviewModalImageHoverItem)
